export default {
  title: 'Log de Erros',
  cleanupOld: 'Limpar Antigos',
  refresh: 'Atualizar',
  selected: 'selecionados',
  markResolved: 'Marcar Resolvido',
  markOpen: 'Marcar Aberto',
  clear: 'Limpar',
  startDate: 'Data de Início',
  endDate: 'Data de Fim',
  errorType: 'Tipo de Erro',
  status: 'Status',
  searchPlaceholder: 'Buscar mensagem ou usuário',
  type: 'Tipo',
  message: 'Mensagem',
  user: 'Usuário',
  timestamp: 'Data e Hora',
  anonymous: 'Anônimo',
  resolved: 'Resolvido',
  open: 'Aberto',
  errorDetails: 'Detalhes do Erro',
  errorName: 'Nome do Erro',
  url: 'URL',
  route: 'Rota',
  unknown: 'Desconhecido',
  userAgent: 'User Agent',
  resolvedAt: 'Resolvido em',
  context: 'Contexto',
  stackTrace: 'Stack Trace',
  noErrorLogs: 'Nenhum registro de erro encontrado',
  cleanupOldErrors: 'Limpar Erros Antigos',
  cleanupMessage: 'Isso excluirá permanentemente os registros de erros com mais de {days} dias.',
  daysToKeep: 'Dias a manter',
  cancel: 'Cancelar',
  delete: 'Excluir',
  javascript: 'JavaScript',
  vue: 'Vue',
  promise: 'Promise',
  manual: 'Manual',
  warning: 'Aviso',
  info: 'Informação',
  failedToLoadLogs: 'Erro ao carregar os registros de erros',
  errorMarkedAs: 'Erro marcado como {status}',
  failedToUpdateStatus: 'Erro ao atualizar o status do erro',
  noErrorsSelected: 'Nenhum erro selecionado',
  errorsMarkedAs: '{count} erros marcados como {status}',
  failedBulkUpdate: 'Erro ao atualizar os erros em lote',
  deletedOldLogs: '{count} registros de erros antigos foram excluídos',
  failedCleanup: 'Erro ao limpar os registros antigos'
}
